"use strict";
/**
 * School-Authored InkStep Content shared types.
 *
 * WP-071: School-Authored InkStep Content (browser mic/camera, content bucket, review queue).
 * Schools can author their own InkStep content (audio pronunciations, decodable texts,
 * flashcards) using browser-based recording tools. This content is org-scoped (not
 * marketplace), goes through a review queue (DSL/admin approval), and is stored in a
 * separate MinIO bucket path (`content/{orgId}/inkstep/`).
 */
Object.defineProperty(exports, "__esModule", { value: true });
